import classNames from 'classnames';
import dynamic from 'next/dynamic';

import styles from './modal-selection.module.scss';

const ModalDynamicComparison = dynamic(
  () =>
    import(
      '../modal-printer-dynamic-comparison/modal-printer-dynamic-comparison'
    ),
  {
    ssr: false,
  }
);
const ModalInkPlans = dynamic(
  () => import('../modal-ink-plans/modal-ink-plans'),
  {
    ssr: false,
  }
);
const ModalAddPaper = dynamic(
  () => import('../modal-add-paper/modal-add-paper'),
  {
    ssr: false,
  }
);

const selectModal = (
  modalName: string,
  isDisabled?: boolean,
  enableVisIDStyles?: boolean
) => {
  switch (modalName) {
    case 'dynamicComparison':
      return <ModalDynamicComparison enableVisIDStyles={enableVisIDStyles} />;
    case 'instantInk':
      return <ModalInkPlans isDisabled={isDisabled} />;
    case 'instantPaper':
      return <ModalAddPaper isBanner={false} isDisabled={isDisabled} />;
    default:
      return null;
  }
};

interface ModalSelectionProps {
  modalName: string;
  isDisabled?: boolean;
  enableVisIDStyles?: boolean;
}

function ModalSelection({
  modalName,
  isDisabled,
  enableVisIDStyles,
}: Readonly<ModalSelectionProps>) {
  return (
    <div className={classNames({ [styles['container']]: !enableVisIDStyles })}>
      {selectModal(modalName, isDisabled, enableVisIDStyles)}
    </div>
  );
}

export default ModalSelection;
